import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { initializeApp } from 'firebase/app';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { unregisterNotificationModel } from 'src/app/shared/model/registerNotification.model';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage/local-storage.service';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { UtilitiesService } from 'src/app/shared/services/utilities/utilities.service';
import { CommonSharedServiceService } from 'src/app/shared/shared-services/common-shared-service/common-shared-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-logged-in-header',
  templateUrl: './logged-in-header.component.html',
  styleUrl: './logged-in-header.component.scss',
})
export class LoggedInHeaderComponent implements OnInit {
  message: any;
  private userId: string = null;
  public userName: string = '';
  public userEmail: string = '';
  public userNameFirstLetter: string = '';

  public currentUrl: string = '';
  public isBookmarkPage: boolean = false;

  public notifications: any[] = [];
  public unregisterModel: unregisterNotificationModel;

  public notificationList: any[] = [];
  public seenNotificationList: any[] = [];
  public unseenNotificationList: any[] = [];

  public unreadNotifications: number;
  public showNotification: boolean = false;
  private authSubscription!: Subscription;
  private deviceInfo: DeviceInfo;

  public env_stage: boolean = environment?.envName === 'stage' ? true : false;

  public isNotificationVisible: boolean = false;
  public sessionUserId: string = null;
  public userSelectedRoleId: string = null;
  public roles;
  constructor(
    public readonly router: Router,
    public readonly authService: AuthService,
    public readonly utilitiesService: UtilitiesService,
    public readonly localStorageService: LocalStorageService,
    private readonly deviceService: DeviceDetectorService,
    private readonly notificationService: NotificationService,
    private readonly commonSharedService: CommonSharedServiceService
  ) {
    this.unregisterModel = new unregisterNotificationModel();
    this.sessionUserId = this.localStorageService.getSessionUser().id;
  }

  async ngOnInit() {
    const sessionUser = this.localStorageService.getSessionUser();
    this.roles = sessionUser?.roles;
    this.userSelectedRoleId =
      this.localStorageService.getSelectedRole().role_id;
    this.userId = sessionUser?.id;
    this.userName = sessionUser?.name
      ? sessionUser.name
      : sessionUser.company_name;
    this.userEmail = sessionUser?.email;
    this.userNameFirstLetter = this.userName.charAt(0);

    this.getBookmarks();
    // this.getNoOfUnreadNotifications();

    this.getCurrentUrl();
    this.isBookmarkPage = this.router.url === '/dashboard/bookmarked-ngos';
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isBookmarkPage = event.url === '/dashboard/bookmarked-ngos';
      }
      this.getCurrentUrl();
    });
    this.authSubscription = this.authService.authState$.subscribe();
    console.log('LoggedInHeaderComponent initialized');
    // this.listen();

    if (!this.localStorageService.getIsNotificationRegistered()) {
      //firebase initialization
      // .............................. //

      const firebaseConfig = environment.firebaseConfig;
      const app = initializeApp(firebaseConfig);

      if (app) {
        try {
          await this.notificationService.registerServiceWorker();
          console.log('Service Worker registration completed');
          this.openNotification();
        } catch (error) {
          console.error('Notification registration failed:', error);
        }
      } else {
        console.error('Firebase initialization failed');
      }
    } else {
      this.openNotification();
    }
    this.notificationService.listenFromFireBaseServer();

    this.commonSharedService.notificationChanged$.subscribe(() => {
      this.openNotification();
    });
  }

  public markAllAsRead(): void {
    if (this.isAllNotRead) {
      this.notifications.forEach((days) => {
        days.forEach((notification) => {
          notification.read = true;
        });
      });
    }
    // this.getNoOfUnreadNotifications();
  }

  public notificationRead(i: number, j: number): void {
    this.notifications[i][j] = true;
    // this.getNoOfUnreadNotifications();
  }

  toggleNotification(event: MouseEvent): void {
    event.stopPropagation(); // Prevent the click event from propagating to the document
    this.isNotificationVisible = !this.isNotificationVisible;
  }
  // Function to handle clicks inside the dropdown (to prevent closing)
  onDropdownClick(event: MouseEvent): void {
    event.stopPropagation(); // Prevent the click inside the dropdown from closing it
  }

  @HostListener('document:click', ['$event'])
  closeNotification(event: Event): void {
    // If the click is outside the dropdown, close the dropdown
    if (!(event.target as Element).closest('.dropdown')) {
      this.isNotificationVisible = false;
    }
  }

  private getBookmarks(): void {
    for (let i = 0; i < 2; i++) {
      this.notifications.push([]);
      for (let j = 0; j < 5; j++) {
        this.notifications[i].push({ read: Math.random() >= 0.5 });
      }
    }
  }

  // private getNoOfUnreadNotifications(): void {
  //   this.unreadNotifications = this.notifications
  //     .flat()
  //     .filter((item) => !item.read).length;
  // }

  private getCurrentUrl(): void {
    const value = this.router.url;
    if (value.includes('bookmarked-ngos')) {
      this.currentUrl = 'Bookmarked NGOs';
    } else if (value.includes('manage/my-organization')) {
      this.currentUrl = 'Manage My NGOs';
    } else if (value.includes('register-new-ngo')) {
      this.currentUrl = 'Register New NGO';
    } else if (value.includes('claim-your-ngo')) {
      this.currentUrl = 'Claim Your NGO';
    } else if (value.includes('update-ngo-profile')) {
      this.currentUrl = 'Manage My NGO';
    } else if (value.includes('create-survey-forms')) {
      this.currentUrl = 'Project: Wash';
    } else if (value.includes('/form/all-questions')) {
      this.currentUrl = 'Project: Wash';
    } else if (value === '/dashboard') {
      this.currentUrl = 'Home';
    }
  }

  public async bookmarkedClicked(): Promise<void> {
    this.router.navigateByUrl('dashboard/bookmarked-ngos');
    //this.DashboardMenuComponent.ngOnInit({ menu_name: '', menu_index: null });
  }
  // public openNotification(): void {
  //   this.showNotification = !this.showNotification;
  // }

  get isAllNotRead(): boolean {
    return this.notifications
      .flat()
      .some((notification) => notification.read === false);
  }

  public logOut(): void {
    this.unRegisterNotificationServer()
      .then(() => {
        this.authService.logout();
        this.router.navigateByUrl('/');
      })
      .catch((error) => {
        console.error('Error during unregistering notifications:', error);
        // Handle the failure (like showing a message), and do not proceed
      });
  }

  public selectedRole(role: any) {
    this.localStorageService.setSelectedRole(role);
    const selectedRole = this.localStorageService.getSelectedRole();
    if (selectedRole) {
      const roleId = role?.role_id;
      this.authService.getMenuByRole(roleId).subscribe({
        next: (response) => {
          const menuList = response.sort(
            (a, b) => Number(a.order) - Number(b.order)
          );
          this.localStorageService.setMenu(menuList);
          this.localStorageService.setSelectedMenuInfo(menuList[0]);
          if (this.localStorageService.getMenu()) {
            if (this.localStorageService.getIsCorporateEmployee()) {
              this.router.navigate(['/employee']);
            } else if (
              this.localStorageService.getIsCampaignManager() ||
              this.localStorageService.getIsCustomEmployee()
            ) {
              this.router.navigate(['/corporate']);
            }
          }
        },
        error: (err) => {
          console.error('Failed to load menu', err);
        },
      });
    }
  }

  public unRegisterNotificationServer(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.deviceInfo = this.deviceService.getDeviceInfo();
      this.unregisterModel.user_id =
        this.localStorageService.getSessionUser()?.id;
      this.unregisterModel.device_id = this.deviceInfo.userAgent;
      this.localStorageService.clearLocalStorageByKey(
        'isNotificationRegistered'
      );
      // resolve();
      this.notificationService
        .unregisterNotification(this.unregisterModel)
        .subscribe(
          (result) => {
            if (result) {
              this.localStorageService.clearLocalStorageByKey(
                'isNotificationRegistered'
              );
              this.unregisterModel = new unregisterNotificationModel();
              console.log('Unregister from notification server.');
              resolve();
            } else {
              reject('Failed to unregister notifications'); // Reject the promise if result is not successful
            }
          },
          (error) => {
            console.error('Error unregistering notifications:', error);
            reject('Error occurred while unregistering notifications'); // Reject if the observable emits an error
          }
        );
    });
  }

  public updateDate(date: string) {
    return this.utilitiesService.getTimeAgo(date);
  }

  public setSeenUnseenNotification(): void {
    this.seenNotificationList = this.notificationList.filter(
      (n: any) => n.isSeen === true
    );

    this.unseenNotificationList = this.notificationList.filter(
      (n: any) => n.isSeen === false
    );

    console.log('Seen Notifications:', this.seenNotificationList);
    console.log('Unseen Notifications:', this.unseenNotificationList);
  }

  public openNotification(): void {
    const sessionUser = this.localStorageService.getSessionUser();

    this.notificationService
      .getAllNotificationByUser(sessionUser?.id)
      .subscribe((result: any) => {
        if (result.status === 'success') {
          this.notificationList = result.resultset
            .map((results) => ({
              ...results,
              data: this.utilitiesService.jsonParse(results.data),
            }))
            .sort((a, b) => {
              if (a.isSeen === false && b.isSeen === true) {
                return -1; // a comes first
              } else if (a.isSeen === true && b.isSeen === false) {
                return 1; // b comes first
              }
              return (
                new Date(b.updated_at).getTime() -
                new Date(a.updated_at).getTime()
              );
            });
          console.log(this.notificationList);
          this.setSeenUnseenNotification();
        }
      });
  }

  public seenNotification(notification: any): void {
    if (notification.isSeen === true) {
      return;
    } else {
      this.notificationService
        .seenSpecificNotifications(
          notification.user_id,
          notification.notification_id
        )
        .subscribe((result) => {
          if (result?.is_updated) {
            this.utilitiesService.showSwalWithToast(
              'Success',
              `${result?.message}`,
              'success'
            );
            notification.isSeen = true;
            this.unseenNotificationList = this.unseenNotificationList.filter(
              (n) => n.notification_id !== notification.notification_id
            );
            this.seenNotificationList.push(notification);
          }
        });
    }
  }

  public markAllNotificationAsRead(userId: string): void {
    this.notificationService
      .seenAllNotifications(userId)
      .subscribe((result) => {
        if (result?.is_updated) {
          this.utilitiesService.showSwalWithToast(
            'Success',
            `${result?.message}`,
            'success'
          );
          this.unseenNotificationList.forEach((notification) => {
            notification.isSeen = true;
          });
          this.unseenNotificationList = [];
          this.seenNotificationList = this.notificationList;
        }
      });
    // this.getNoOfUnreadNotifications();
  }

  public redirectNotification(notification: any): void {
    const data = notification.data;
    const notificationId = notification.notification_id;

    let route = '';

    switch (data?.category) {
      case 'EMPLOYEE_VOUCHER_ASSIGN':
        if (this.localStorageService.getIsCorporateEmployee()) {
          route = '/employee/my-gift';
        } else {
          this.utilitiesService.showSwal(
            'error',
            'Please login as an employee'
          );
        }
        break;

      case 'EMPLOYEE_CAMPAIGN_START':
        if (this.localStorageService.getIsCorporateEmployee()) {
          route = '/employee/campaigns';
        } else {
          this.utilitiesService.showSwal(
            'error',
            'Please login as an employee'
          );
        }
        break;

      case 'EMPLOYEE_EARNED_REWARD':
        if (this.localStorageService.getIsCorporateEmployee()) {
          route = '/employee/my-reward-points';
        } else {
          this.utilitiesService.showSwal(
            'error',
            'Please login as an employee'
          );
        }
        break;

      case 'EMPLOYEE_DONATION_RECEIVED':
        if (this.localStorageService.getIsCorporateEmployee()) {
          route = '/employee/donation-history';
        } else {
          this.utilitiesService.showSwal(
            'error',
            'Please login as an employee'
          );
        }
        break;

      case 'MATCH APPROVED':
        if (this.localStorageService.getIsCorporateEmployee()) {
          route = '/employee/donation-history';
        } else {
          this.utilitiesService.showSwal(
            'error',
            'Please login as an employee'
          );
        }
        break;

      case 'MATCH DENIED':
        if (this.localStorageService.getIsCorporateEmployee()) {
          route = '/employee/campaigns';
        } else {
          this.utilitiesService.showSwal(
            'error',
            'Please login as an employee'
          );
        }
        break;

      case 'CORPORATE_ADMIN_RECEIVED_DONATION':
        if (this.localStorageService.getIsCorporateAdmin()) {
          route = '/corporate/csr-donation/donations';
        } else {
          this.utilitiesService.showSwal(
            'error',
            'Please login as an corporate admin'
          );
        }
        break;

      case 'SHOHAY_ADMIN_PLEDGED_DONATION':
        if (this.localStorageService.getIsSuperAdmin()) {
          route = '/admin/csr-donation/csr-internal-donations';
        } else {
          this.utilitiesService.showSwal(
            'error',
            'Please login as an super admin'
          );
        }
        break;

      case 'CORPORATE_ADMIN_RECEIVED_EXTERNAL_DONATION':
        if (this.localStorageService.getIsCorporateAdmin()) {
          route = '/corporate/csr-donation/donations';
        } else {
          this.utilitiesService.showSwal(
            'error',
            'Please login as an corporate admin'
          );
        }
        break;

      default:
    }
    if (route) {
      this.router.navigate([route], {
        queryParams: { notification: notificationId },
      });
    }
  }

  ngOnDestroy() {}
}
